import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns'
import CustomCard from '../../../components/CustomCard.tsx'
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import styles from '../../../styles/components/register.module.scss'

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks.tsx'

import { useFormContext } from 'react-hook-form'
import { useOidcAccessToken } from '@axa-fr/react-oidc'
import { useEffect } from 'react'
import { fetchBesanFromApiData, fetchTitlesFromApiData } from '../../../redux/settingSlice.tsx'
import { protectedResources } from '../../../global/config.tsx'
import { Salutations } from '../../../types/settingTypes/Salutation.tsx'
import { NwTitle } from '../../../types/settingTypes/NwTitle.tsx'

export const GeneralData = () => {
  const salutationResponse: Salutations[] | null = useAppSelector((state) => state.setting.besanList)
  const titlesResponse: NwTitle[] | null = useAppSelector((state) => state.setting.titleList)

  const dispatch = useAppDispatch()
  const { accessToken } = useOidcAccessToken()
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const requiredMsg = 'Dieses Feld ist ein Pflichtfeld'

  // Hole Titel, Anreden & File Types aus API
  useEffect(() => {
    const besanUrl = `${protectedResources.apiList.readSalutation}`
    const titlesUrl = `${protectedResources.apiList.readTitles}`

    if (accessToken) {
      dispatch(fetchBesanFromApiData({ url: besanUrl, token: accessToken }))
      dispatch(fetchTitlesFromApiData({ url: titlesUrl, token: accessToken }))
    }
  }, [accessToken])

  return (
    <CustomCard header="Allgemeine Informationen">
      <div className="formRow">
        <div>
          <DropDownListComponent
            floatLabelType="Always"
            cssClass={`formElement ${styles.required}`}
            dataSource={
              salutationResponse
                ? salutationResponse
                    .filter((x) => !x.company)
                    .filter((x) => x.salutation !== ' ')
                    .map((x) => x.salutation)
                : []
            }
            {...register('contactSalutation', { required: requiredMsg })}
            placeholder="Anrede"
          />
          <p className="errorMsg">{(errors.contactSalutation?.message as string) || null}</p>
        </div>
        <DropDownListComponent placeholder="Titel" dataSource={titlesResponse ? titlesResponse.filter((x) => x.title).map((x) => x.title) : []} {...register('contactTitle')} floatLabelType="Always" />
      </div>
      <div className="formRow">
        <div>
          <TextBoxComponent locale="de" placeholder="Vorname" cssClass={`${styles.required}`} floatLabelType="Always" {...register('contactForename', { required: requiredMsg })} />
          <p className="errorMsg">{(errors.contactForename?.message as string) || null}</p>
        </div>

        <div>
          <TextBoxComponent placeholder="Nachname" cssClass={`${styles.required}`} floatLabelType="Always" {...register('contactSurname', { required: requiredMsg })} />
          <p className="errorMsg">{(errors.contactSurname?.message as string) || null}</p>
        </div>
      </div>
    </CustomCard>
  )
}
